<template>
  <div v-if="showCtaLabel && !loading">
    <div v-if="shopData?.Display.Mode === 'Simple'" class="_rfp_mctb_mc_02_">
      <rfp-mctb-simple-single-retailer
        :product="shopData.Product"
        :buy-now-text="buyNow"
      ></rfp-mctb-simple-single-retailer>
    </div>

    <div v-else-if="shopData?.Display.Mode === 'Direct'" class="_rfp_mctb_mc_04_">
      <rfp-mctb-simple-mode
        :view-type="shopData.Display.View"
        :retailer-details="shopData"
        :header-text="carouselHeader"
        :enable-rtl="enableRtl"
        :retailer-unavailable="retailerUnavailable"
        :component-diffs="componentDiffs"
        :productname="shopData.Product.Title"
        :productids="shopData.Product.ProductId"
      >
      </rfp-mctb-simple-mode>
    </div>
    <div v-else-if="shopData?.Display.Mode === 'Popup-optional'" class="_rfp_mctb_mc_05_">
      <rfp-mctb-pop-up-action-mode
        :retailer-unavailable="retailerUnavailable"
        :header-text="carouselHeader"
        :component-diff="componentDiffs"
        close-icon-text="Close window"
        :initial-data="shopData"
        :productname="shopData.Product.Title"
        :productids="shopData.Product.ProductId"
        :initial-extra-params="extraParams"
      >
      </rfp-mctb-pop-up-action-mode>
    </div>
    <div v-else-if="shopData?.Display.Mode === 'Popup'" class="_rfp_mctb_mc_05_">
      <rfp-mctb-pop-up-mode
        :view-type="shopData.Display.View"
        :retailer-unavailable="retailerUnavailable"
        :enable-rtl="enableRtl"
        :buy-now-text="buyNow"
        :carousel-header-text="carouselHeader"
        :store-locator-mode-options="shopData"
        :component-diffs="componentDiffs"
        :productname="shopData.Product.Title"
        :productids="shopData.Product.ProductId"
      >
      </rfp-mctb-pop-up-mode>
    </div>
    <div v-if="shopData?.Product.BuyOffline?.IsActive && shopData.Product.BuyOffline?.OfflineUrl">
      <rfp-mctb-store-locator-mode
        :buy-offline="shopData.Product.BuyOffline"
        :offline-button-text="buyOfflineButtonText"
        :productname="shopData.Product.Title"
        :productids="shopData.Product.ProductId"
      >
      </rfp-mctb-store-locator-mode>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpMctbSimpleSingleRetailer from './rfp-mctb-simple-single-retailer/rfp-mctb-simple-single-retailer.vue';
import RfpMctbPopUpMode from './rfp-mctb-pop-up-mode/rfp-mctb-pop-up-mode.vue';
import RfpMctbPopUpActionMode from './rfp-mctb-pop-up-action-mode/rfp-mctb-pop-up-action-mode.vue';
import RfpMctbSimpleMode from './rfp-mctb-simple-mode/rfp-mctb-simple-mode.vue';
import RfpMctbStoreLocatorMode from './rfp-mctb-store-locator-mode/rfp-mctb-store-locator-mode.vue';
import ServiceType from './rfp-mctb-tags/tagging-service-type';

const Events = {
  EnablePopupDirection: 'rfp-mctb-enable-popup-direction',
  AutoPopupOpen: 'rfp-auto-popup-open-buynow-true',
  DefaultVariant: 'default-variant',
  ScanToBuyRedirect: 'rfp-mctb-scan-to-buy-redirect',
  TaggingFoundation: 'rfpTaggingFoundation',
  ExtraParam: 'rfp-mctb-extra-param-component',
};

const Actions = {
  HideCta: 'Hide CTA',
  DelayDisplay: 'Delay Display',
  DisplayRetailer: 'Display Retailer',
};

export default {
  name: 'rfp-mctb-main-container',
  components: {
    RfpMctbSimpleSingleRetailer,
    RfpMctbPopUpMode,
    RfpMctbPopUpActionMode,
    RfpMctbSimpleMode,
    RfpMctbStoreLocatorMode,
  },
  props: {
    buynowData: {
      type: Object,
      required: true,
    },
    buyOnlineButtonText: {
      type: String,
      default: 'Online',
    },
    buyOfflineButtonText: {
      type: String,
      default: 'Offline',
    },
    carouselHeader: {
      type: String,
      default: 'Carousel Header',
    },
    buyNow: {
      type: String,
      default: 'Buy Now',
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    sportLiteMode: {
      type: Boolean,
      required: true,
    },
    useCommerceConnector: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const params = new URLSearchParams(window.location.search.toLowerCase());
    const action = this.buynowData?.Action;
    const scanToBuyQueryStrings = this.buynowData?.ScanToBuyRedirect.ScanToBuyQueryStrings;
    const urlParamsRetailer = [];
    if (scanToBuyQueryStrings) {
      for (let value of scanToBuyQueryStrings.values()) {
        if (params.get(value.Key.toLowerCase()) === value.Value.toLowerCase()) {
          urlParamsRetailer.push(value);
        }
      }
    }
    return {
      extraParams: {},
      showCtaLabel: true,
      delayDisplayTime: action?.DelayTimer * 1000,
      QuerystringParamValue: action?.QuerystringParamValue.toLowerCase(),
      urlParams: params.get(action?.QuerystringParamName.toLowerCase()),
      urlParamsRetailer,
      commerceConnectorApi: '/newrefapp/commerceconnector/onlineshops',
      shopData: this.buynowData,
      loading: this.useCommerceConnector,
    };
  },
  watch: {
    buynowData(data) {
      this.shopData = data;
    },
  },
  mounted() {
    this.init(this.useCommerceConnector);
  },
  methods: {
    async init(useCommerceConnector) {
      if (useCommerceConnector) {
        const data = await this.getCommerceConnectorData();
        this.mapShopData(data);
        this.loading = false;
      }
      const action = this.shopData?.Action;
      this.setupCta(action);
      this.setupEvents(action);
    },
    async getCommerceConnectorData() {
      try {
        const params = new URLSearchParams({
          productEanOrUpc: this.shopData.Product.ProductId,
        });
        const url = `${this.commerceConnectorApi}?${params}`;

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Pragma: 'no-cache',
          },
        });
        if (!response.ok) throw new Error(`HTTP error ${response.status}`);
        return await response.json();
      } catch (err) {
        console.error(err);
      }
    },
    mapShopData(data) {
      this.shopData.CountryList = this.mapCountryList(data);
      this.shopData.Product.Retailers = this.mapRetailers(data.flatMap((item) => item.shops));
    },
    mapCountryList(data) {
      return data.map((country) => ({
        DisplayName: country.shops[0].addressInfo.Country,
        Name: country.shops[0].addressInfo.Country,
      }));
    },
    mapRetailers(shops) {
      return shops.map((shop) => ({
        Country: shop.addressInfo.Country,
        Description: shop.description,
        IsActive: true,
        Logo: shop.logo,
        LogoAlt: '',
        Name: shop.title,
        OpenInNewWindow: true,
        ProductItemId: this.shopData.Product.ProductId,
        RetailerItemId: shop.id,
        RetailerTags: this.shopData.Product.BuyOnlineSimpleModeTags,
        RetailerTagsGS: this.shopData.Product.BuyOnlineSimpleModeTagsGS,
        RetailerUrl: shop.offerInfo.Offers[0].Deeplink,
        SortOrder: '',
        VariantItemId: '',
      }));
    },
    autoPopupEvent() {
      if (this.urlParams === this.QuerystringParamValue) {
        eventBus.emit(Events.AutoPopupOpen);
      }
    },
    setupCta(action) {
      if (
        !this.shopData?.ScanToBuyRedirect.EnableScanToBuyRedirect &&
        this.urlParams === this.QuerystringParamValue
      ) {
        if (action?.Name === Actions.HideCta) {
          this.showCtaLabel = false;
        }

        if (action?.Name === Actions.DelayDisplay) {
          this.showCtaLabel = false;
          this.hideShowCta();
        }
      }
    },
    setupEvents(action) {
      if (
        !this.shopData?.ScanToBuyRedirect.EnableScanToBuyRedirect &&
        action?.Name === Actions.DisplayRetailer &&
        this.shopData.Display.Mode === 'Popup' &&
        !this.sportLiteMode &&
        this.urlParams === this.QuerystringParamValue
      ) {
        this.autoPopupEvent();
      }
      eventBus.emit(Events.DefaultVariant);
      eventBus.on(Events.ScanToBuyRedirect, (val) => {
        if (!val) {
          if (this.shopData.Product.Retailers.find(this.findRetailerData) && !this.sportLiteMode) {
            this.redirectRetailers(this.shopData.Product.Retailers.find(this.findRetailerData));
          } else {
            eventBus.emit(Events.EnablePopupDirection);
          }
        }
      });
      eventBus.on(Events.TaggingFoundation, (values) => {
        if (!window.wsf) {
          window.wsf = { refappMoreinformation: values };
        } else {
          window.wsf.refappMoreinformation = values;
        }
      });

      eventBus.on(Events.ExtraParam, (val) => {
        this.extraParams = val;
      });
    },
    hideShowCta() {
      this.hideShowCtaAction();
    },
    hideShowCtaAction() {
      if (this.shopData.Action.Name != Actions.HideCta) {
        this.showCtaLabel = true;
      }
    },
    findRetailerData(retailer) {
      const configuredRetailerName = this.$cookies.get('ERetailerName');
      return retailer?.Name.toLowerCase() === configuredRetailerName?.toLowerCase();
    },
    redirectRetailers(retailerInfo) {
      if (
        this.shopData?.ScanToBuyRedirect.EnableScanToBuyRedirect &&
        this.urlParamsRetailer.length > 0
      ) {
        if (window.dataLayer) {
          let tags = {};
          try {
            tags = JSON.parse(this.shopData.Product.BuyOnlineSimpleModeTags);
          } catch (e) {
            console.log(
              'error/rfp-mctb-main-container#redirectRetailers: Standard (GA) tag parsing failed',
              e,
            );
          }
          eventBus.emit(Events.TaggingFoundation, {
            data: tags,
            values: {
              productName: this.shopData.Product.Title,
              productId: this.shopData.Product.ProductId,
              retailerName: retailerInfo.Name,
            },
            service: ServiceType.GA,
          });
        }
        const target = retailerInfo.OpenInNewWindow === true ? '_blank' : '_self';
        return window.open(retailerInfo.RetailerUrl, target);
      }
      eventBus.emit(Events.EnablePopupDirection);
    },
  },
};
</script>
